module.exports = __webpack_public_path__ + "img/avatarSerbia.07b6c6c8.png";